<template>
  <div class="account-body accountbg admin">
    <div class="row vh-100">
      <div class="col-12 align-self-center">
        <div class="auth-page">
          <div class="card auth-card shadow-lg">
            <div class="card-body">
              <div class="px-3">
                <div class="auth-logo-box">
                  <a href="#" class="logo logo-admin"
                    ><img
                      src="@/assets/custom-images/logo-sm.png"
                      height="55"
                      alt="logo"
                      class="auth-logo"
                  /></a>
                </div>

                <div class="text-center auth-logo-text">
                  <h4 class="mt-0 mb-1 mt-5" style="font-size: 18px">
                    Selamat Datang di Administrator BPD BALI
                  </h4>
                  <p class="text-muted mb-0">
                    Masuk untuk melanjutkan ke administrator BPD BALI
                  </p>
                </div>

                <form
                  class="form-horizontal auth-form my-4"
                  @submit.prevent="signIn()"
                >
                  <div
                    class="form-group"
                    :class="{ 'is-invalid': $v.loginData.username.$error }"
                  >
                    <label>Username</label>

                    <input
                      type="text"
                      class="form-control"
                      :disabled="loading"
                      v-model.trim="$v.loginData.username.$model"
                      placeholder="Masukkan Username"
                    />

                    <div class="error" v-if="!$v.loginData.username.required">
                      Username wajib di isi
                    </div>
                    <!-- <div class="error" v-if="!$v.loginData.username.email">Masukkan alamat email dengan benar</div> -->
                  </div>

                  <div
                    class="form-group"
                    :class="{ 'is-invalid': $v.loginData.password.$error }"
                  >
                    <label>Kata Sandi</label>

                    <input
                      type="password"
                      class="form-control"
                      :disabled="loading"
                      v-model.trim="$v.loginData.password.$model"
                      placeholder="Masukkan Kata Sandi"
                    />

                    <div class="error" v-if="!$v.loginData.password.required">
                      kata Sandi wajib di isi
                    </div>
                    <!-- <div class="error" v-if="!$v.loginData.password.minLength">Kata Sandi minimal 6 karakter</div> -->
                  </div>

                  <!-- <div class="form-group row mt-4">
                                        <div class="col-sm-6">
                                            <div class="custom-control custom-switch switch-success">
                                                <input type="checkbox" class="custom-control-input"
                                                    id="customSwitchSuccess">
                                                <label class="custom-control-label text-muted"
                                                    for="customSwitchSuccess">Ingat Saya</label>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <a href="#" class="text-muted font-13"><i
                                                    class="dripicons-lock"></i> Forgot password?</a>
                                        </div>
                                    </div> -->

                  <div class="form-group mb-0 row">
                    <div class="col-12 mt-2">
                      <button
                        class="
                          btn btn-primary btn-round btn-block
                          waves-effect waves-light
                        "
                        :disabled="loading"
                        type="submit"
                      >
                        <div v-if="!loading">
                          Masuk <i class="fas fa-sign-in-alt ml-1"></i>
                        </div>
                        <div
                          class="spinner-border text-light"
                          role="status"
                          v-else
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, minLength, between, email } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      loading: false,
      loginData: {
        username: "",
        password: "",
      },
    };
  },
  validations: {
    loginData: {
      username: {
        required,
        // email
      },
      password: {
        required,
        // minLength: minLength(6)
      },
    },
  },
  methods: {
    signIn() {
      if (this.$v.loginData.$invalid) {
        this.$v.$touch();
        this.sAlert("error", "Harap isi semua form dengan benar!");
        return;
      }

      this.loading = true;

      const form = {
        username: this.encryptData(this.loginData.username),
        password: this.encryptData(this.loginData.password),
      };

      this.$http
        .post(`${this.API_URL}auth/administrator/login`, form)
        .then((response) => {
          const result = response.data;

          if (result.success) {
            var date = new Date();
            date.setDate(date.getDate() + 1);
            this.$cookies.set("type_user_login", "admin", date);
            this.$cookies.set("token_admin", result.data.access_token, date);
            this.$cookies.set("data_admin", JSON.stringify(result.data), date);

            this.$cookies.remove("token_instance");
            this.$cookies.remove("data_instance");

            this.$router.push("/admin");
          } else {
            this.sAlert("error", result.message);
          }
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.sAlert("error", "Username atau kata sandi salah!");
        });
    },
  },
};
</script>

<style>
</style>